import { render, staticRenderFns } from "./NotHQIM.vue?vue&type=template&id=61055182&scoped=true"
import script from "./NotHQIM.vue?vue&type=script&lang=js"
export * from "./NotHQIM.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61055182",
  null
  
)

export default component.exports